import { VBottomSheet } from 'vuetify/lib/components/VBottomSheet';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { "data-qa": "appointment-restrictions" } },
    [
      _c(
        _setup.CoreDialog,
        {
          attrs: {
            "data-qa": "appointment-restrictions-request-modal",
            size: "sm",
          },
          model: {
            value: _setup.isOpenedRequestDialog,
            callback: function ($$v) {
              _setup.isOpenedRequestDialog = $$v
            },
            expression: "isOpenedRequestDialog",
          },
        },
        [
          _c(
            "div",
            {
              staticClass:
                "d-flex flex-column align-center justify-center py-10",
              attrs: { "data-qa": "modal-content-progress" },
            },
            [
              _c(VProgressCircular, {
                attrs: {
                  width: "2.5",
                  size: "42",
                  color: "primary",
                  indeterminate: "",
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _setup.isMobile
        ? _c(
            VBottomSheet,
            {
              attrs: { scrollable: "" },
              model: {
                value: _setup.isOpenedContentDialog,
                callback: function ($$v) {
                  _setup.isOpenedContentDialog = $$v
                },
                expression: "isOpenedContentDialog",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "appointment-restrictions appointment-restrictions--mobile bg-gray-0 d-flex flex-column",
                  attrs: { "data-qa": "appointment-restrictions-modal-body" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "text-h6 text--text pt-6 px-4 pb-4" },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_setup.TEXT.restrictions) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(_setup.ModalContent, {
                    staticClass: "px-4 pb-4",
                    attrs: {
                      "is-opened": _setup.isOpenedContentDialog,
                      "lpu-name": _setup.lpuName,
                      "restrictions-data-list":
                        _setup.appointmentRestrictionsDataList,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "pa-2" },
                    [
                      _c(
                        VBtn,
                        {
                          staticClass: "branding-btn branding-btn--primary",
                          attrs: { color: "primary", depressed: "", block: "" },
                          on: {
                            click: function ($event) {
                              _setup.isOpenedContentDialog = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_setup.TEXT.confirm) +
                              "\n        "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          )
        : _c(
            _setup.CoreDialog,
            {
              attrs: {
                size: "md",
                title: _setup.TEXT.restrictions,
                "content-class": "appointment-restrictions-modal",
                "data-qa": "appointment-restrictions-modal",
                divider: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "actions",
                  fn: function () {
                    return [
                      _c(
                        VBtn,
                        {
                          staticClass: "branding-btn branding-btn--primary",
                          attrs: {
                            "data-qa": "modal-actions-btn-close",
                            color: "primary",
                            block: "",
                            depressed: "",
                          },
                          on: {
                            click: function ($event) {
                              _setup.isOpenedContentDialog = false
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_setup.TEXT.confirm) +
                              "\n      "
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _setup.isOpenedContentDialog,
                callback: function ($$v) {
                  _setup.isOpenedContentDialog = $$v
                },
                expression: "isOpenedContentDialog",
              },
            },
            [
              _c(_setup.ModalContent, {
                attrs: {
                  "is-opened": _setup.isOpenedContentDialog,
                  "lpu-name": _setup.lpuName,
                  "restrictions-data-list":
                    _setup.appointmentRestrictionsDataList,
                },
              }),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }